import { getHotelCemFilter } from '@/storage/services/hotelcem/CommonFilterService'
import { getUserInfo } from '@/storage/services/AppBaseConfigService'

function getHotelInfo() {
  let value = {}
  let hotelInfo = getHotelCemFilter()
  if (hotelInfo && hotelInfo.hotelInfo) {
    value.hotelId = hotelInfo.hotelInfo.value
    value.hotelName = hotelInfo.hotelInfo.label
  }
  return value
}

class UBT {
  constructor() {
    this._event = null
  }

  sendEvent(key, value = {}) {
    let event = {}
    const eventKey = 'v:cem'
    if (this._event) {
      event = this._event
    } else {
      event = new Event(eventKey)
      this._event = event
    }
    event.key = eventKey
    /**
     * event:{
     *  key: 'v:rms',  //事件主标识，用于matomo监听window事件
     *  value: {
     *      traceKey:String,  //业务标识
     *      ...Otherobject   //其他自定义参数
     *    }
     * }
     *
     */
    event.value = { ...value, traceKey: key }
    window.dispatchEvent(event)
    console.log('sendEvent', event)
  }
}

export default new UBT()
